import copy from 'fast-copy'

export abstract class Stash<T> {
  TAG = 'Stash'
  previous: T
  current: T

  constructor(initialValue: T = null) {
    this.current = initialValue
  }

  stash(item: T) {
    console.log(`${this.TAG}#stash`, item)
    if (this.current) this.previous = this.current
    this.current = copy(item)
  }

  isChanged(equalityCallback?: (a, b) => boolean) {
    console.log(`${this.TAG}#isChanged`, this.previous, this.current)

    if (!this.current) return false
    if (!this.previous && this.current) {
      console.log(`${this.TAG}#isChanged: !this.previous && this.current`)
      return true
    }

    return this.isChangedImpl(equalityCallback)
  }

  protected abstract isChangedImpl(equalityCallback?: (a, b) => boolean): boolean
}
